import React from "react";
import styled from "styled-components/macro";

export const StyledButton = styled.button`
	background: ${({ disabled }) => (disabled ? "#E9D79D" : "#F1C232")};
	color: ${({ disabled }) => (disabled ? "#FCFCFD" : "#111111")};
	border: none;
	border-radius: 5px;
	padding: 0.6rem 1rem;

	font-weight: 600;
	font-size: 15px;
	line-height: 22px;
	cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
	align-self: ${({ alignTo }) => (alignTo === "left" && "flex-start") || (alignTo === "right" && "flex-end") || "stretch"};
`;
const SaveButton = (props) => <StyledButton {...props}>{props.label}</StyledButton>;

export default SaveButton;
